import {Nullable, PaginationType, RatingType} from "../../definitions/types";
import {PaginationModel} from "./paginationModel";
import {RatingModel} from "./ratingModel";

export class RatingPaginationModel {
    private readonly _ratings: RatingModel[];
    private readonly _pagination: PaginationModel;

    constructor(public readonly nullableRatingTypes: Nullable<RatingType>[], public readonly nullablePaginationType: Nullable<PaginationType>) {
        this._pagination = new PaginationModel(nullablePaginationType);
        this._ratings = nullableRatingTypes
            .filter((rating): rating is RatingType => rating !== null)
            .map((ratingType) => new RatingModel(ratingType));
    }

    /**
     * @method ratings
     * @description Returns the ratings for the product in the pagination.
     * @returns {RatingModel[]}
     */
    public get ratings(): RatingModel[] {
        return this._ratings;
    }

    /**
     * @method pagination
     * @description Returns the pagination for the ratings of the product.
     * @returns {PaginationModel}
     */
    public get pagination(): PaginationModel {
        return this._pagination;
    }
}